

























































































































































































































































































































import store from "@/store";
import moment from "moment";
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import DiagnosticTypesHelper from "Utilities/diagnostic-types-helper";
//modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import VesselEventsModule from "@/store/clients/VesselEvents.module";
import LongTrendsModule from "@/store/clients/LongTrends.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
//types
import { ILongTrend } from "@/types/longTrend";
import { ExtendedVessel } from "@/types/vessel";
import { ILongTrendPeriod } from "@/types/longTrendPeriod";
import { VesselEvent } from "@/types/vesselEvent";
import { IPlotLine, DefaultVesselEventPlotline } from "@/types/highcharts/plotLine";
import { IPlotBand } from "@/types/highcharts/plotBand";
import { IDataSerie } from "@/types/highcharts/dataSerie";
//components
import GraphCard from "@/components/diagnosticsDetails/GraphCard.vue";
import { Chart } from "highcharts-vue";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
import Highcharts from "highcharts";
import LoadingTextWave from "@/components/LoadingTextWave.vue";
import TrendEventImpactModal from "@/components/diagnostics/TrendEventImpactModal.vue";
import { LongTrendPeriodMeta } from "@/types/longTrendPeriodMeta";
import LongTrendFilterForm from "@/components/diagnostics/LongTrendFilterForm.vue";
import HullCoatingIndicator from "@/components/HullCoatingIndicator.vue";
import SpeedMeasurementIndicator from "@/components/SpeedMeasurementIndicator.vue";

HighchartsNoData(Highcharts);

const Vessels = getModule(VesselsModule, store);
const VesselEvents = getModule(VesselEventsModule, store);
const LongTrends = getModule(LongTrendsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    LoadingTextWave,
    GraphCard,
    Highcharts: Chart,
    TrendEventImpactModal,
    LongTrendFilterForm,
    HullCoatingIndicator,
    SpeedMeasurementIndicator,
  },
})
export default class DiagnosticCard extends Vue {
  @Prop() readonly longTrendName!: string;
  @Prop() readonly visible!: boolean;
  @Prop() readonly hasFilterUpdated!: boolean;
  @Ref() readonly chart!: any;

  //  @Data
  benchmarkTypeList: string[] = ["Automatic", "Manual"];
  benchmarkType: string = this.benchmarkTypeList[0];
  TrendEventImpactModal = false;
  showError = false;
  useManualBenchmarkLevel = false;
  manualBenchmarkLevel = 0;
  isLongTrendsLoading = true;
  isBenchmarkLevelSettingsLoading = false;
  OriginalBenchmarkSettings = {
    benchmarkType: "",
    manualBenchmarkLevel: 0,
    useManualBenchmarkLevel: false,
    isBenchmarkMenuOpen: false,
  };

  async created(): Promise<void> {
    if (!this.vessel || !this.longTrend) {
      this.showError = true;
      this.isLongTrendsLoading = false;
    } else {
      try {
        await Promise.all([LongTrends.fetchVesselLongTrendPeriods({ vesselId: this.vessel.id, longTrend: this.longTrend })]);
        this.benchmarkType = this.longTrend.useManualBenchmarkLevel ? this.benchmarkTypeList[1] : this.benchmarkTypeList[0];
        this.manualBenchmarkLevel = this.longTrend.manualBenchmarkLevel;
        this.useManualBenchmarkLevel = this.longTrend.useManualBenchmarkLevel;
      } catch (error) {
        this.showError = true;
        console.warn(error);
      } finally {
        this.isLongTrendsLoading = false;
      }
    }
  }

  @Watch("vesselEvents")
  onVesselEventsChanged(): void {
    if (!this.vessel) return;

    LongTrends.fetchVesselLongTrendPeriods({ vesselId: this.vessel.id, longTrend: this.longTrend });
  }

  get longTrend(): ILongTrend {
    return LongTrends.vesselLongTrendByName(this.longTrendName).longTrend;
  }

  get longTrendPeriods(): ILongTrendPeriod[] {
    return this.longTrend ? LongTrends.vesselLongTrendByName(this.longTrendName).longTrendPeriods : [];
  }

  get vesselEvents(): VesselEvent[] {
    return VesselEvents.allEvents;
  }

  get firstLongTrendPeriod(): ILongTrendPeriod | undefined {
    if (!this.longTrendPeriods?.length) return;
    return this.longTrendPeriods[0];
  }

  get getDraftValue(): number {
    return this.firstLongTrendPeriod?.draft ?? 0;
  }

  get tooltipText(): string {
    return DiagnosticTypesHelper.getHelpText(this.longTrend.diagnosticType);
  }

  get hasNoTrendEvents(): any {
    return !VesselEvents.trendEvents?.length;
  }

  get vessel(): ExtendedVessel | null {
    if (!Vessels.currentVessel) return null;
    return Vessels.currentVessel;
  }

  get loadingText(): string {
    return this.hasFilterUpdated ? "LOADING NEW FILTER..." : "";
  }

  get isBenchmarkTypeAutomatic(): boolean {
    return this.benchmarkType === this.benchmarkTypeList[0];
  }

  get isCloudLongTrendFeatureEnabled(): boolean {
    if (!this.vessel) return false;
    return this.vessel.features.some(feature => feature.name === "CloudLongTrend");
  }

  get longTrendShortDescription(): string {
    if (!this.longTrend.description) return "";
    return this.longTrend.description.split(",")[0] ?? "";
  }

  //  @Methods
  themeColor(color: string): string {
    return (this.$vuetify.theme.themes[this.$vuetify.theme.dark ? "dark" : "light"][color] as any) ?? this.$vuetify.theme.themes.light[color];
  }

  getVesselEventsOnSameDate(eventTimestamp: string): VesselEvent[] {
    return this.vesselEvents.filter((vesselEvent: VesselEvent) => vesselEvent.timestamp === eventTimestamp);
  }

  getPlotLineLabels(vesselEventsOnSameDate: VesselEvent[], event: VesselEvent): string {
    return `
          <span class="plot-line-label-icon mdi ${this.eventIcon(event.type)}">
          <i
          class="multiple-event-counter"
          style="display: ${vesselEventsOnSameDate.length >= 2 ? "block" : "none"}"
          >
          ${vesselEventsOnSameDate.length}
          </i>
          </span>
          <div class="plot-line-tooltip v-tooltip__content dfi-tooltip dark bottom">
          ${vesselEventsOnSameDate
            .map(
              (vesselEvent: VesselEvent, index: number) => `
          <p class="mb-1">
            <i
              class="plot-line-label-icon mdi ${this.eventIcon(vesselEvent.type)} mr-2"
              style="display: ${vesselEventsOnSameDate.length >= 2 ? "block" : "none"}; height: 18px;"
            ></i>
            <b class="text-s-medium ContentInversePrimaryStatic--text">${this.formatDateForDisplay(vesselEvent.timestamp)}</b>
          </p>
          <p class="text-s-regular ContentInverseSecondaryStatic--text">${vesselEvent.name}</p>
          <hr class="my-2" style="display: ${vesselEventsOnSameDate.length - 1 === index ? "none" : "block"}; border-top: 1px solid ${this.themeColor(
                "ContentInverseSecondaryStatic"
              )}; border-bottom: 0;" />
          `
            )
            .join("")}
          </div>
          `;
  }

  get vesselEventPlotLines(): IPlotLine[] {
    const plotLines: IPlotLine[] = [];

    this.vesselEvents.forEach(event => {
      const html = this.getPlotLineLabels(this.getVesselEventsOnSameDate(event.timestamp), event);
      plotLines.push(
        Object.assign(JSON.parse(JSON.stringify(DefaultVesselEventPlotline)), {
          id: `plotline-${event.id}`,
          color: this.eventColor(event.type),
          value: moment.utc(event.timestamp).valueOf(),
          width: 2,
          label: {
            rotation: 0,
            style: { color: this.eventColor(event.type) },
            text: html,
            useHTML: true,
            y: -15,
            x: -11,
          },
        })
      );
    });

    return plotLines;
  }

  get vesselEventPlotBands(): IPlotBand[] {
    const plotBands: IPlotBand[] = [];

    this.longTrendPeriods.forEach(period => {
      plotBands.push({
        from: moment.utc(period.start).valueOf(),
        to: moment.utc(period.end).valueOf(),
        id: period.longTrendId,
        className: "diagnotic-graph__plot-bands",
        color: "rgba(0,0,0,0.0)",
        zIndex: 4,
        events: {
          click: (e: any) => {
            setTimeout(() => {
              if (e.xAxis || e.yAxis) this.$emit("plotBandClicked", this.getLongTrendPeriodMeta(period));
            });
          },
          mouseover: (e: any) => {
            e.target.attributes.getNamedItem("fill").value = "#085A8B0d";
          },
          mouseout: (e: any) => {
            e.target.attributes.getNamedItem("fill").value = "rgba(0,0,0,0.0)";
          },
        },
      });
    });

    return plotBands;
  }

  get dataSeries(): IDataSerie[] {
    if (!this.longTrend) {
      this.showError = true;
      return [];
    } else {
      const series: IDataSerie[] = [];
      const longTrendData: [number, number][] = [];
      const benchmarkingData: any[] = [];

      this.longTrendPeriods.forEach(period => {
        //graph points for long trend data
        period.longTrendData.forEach(dataPoint => {
          longTrendData.push([new Date(this.formatDatetimeToUTC(dataPoint.x)).getTime(), dataPoint.y]);
        });

        //graph points for benchmark data
        if (!this.longTrend.useManualBenchmarkLevel && period.benchmarkPoint) {
          benchmarkingData.push(
            [new Date(this.formatDatetimeToUTC(period.benchmarkPoint.x)).getTime(), period.benchmarkPoint.y],
            [new Date(this.formatDatetimeToUTC(period.end)).getTime(), period.benchmarkPoint.y]
          );
        }

        if (period.trendline) {
          series.push({
            name: `Trendline (${this.formatDateForDisplay(period.trendline.start.x)})`,
            type: "line",
            color: this.themeColor("BackgroundDataVizTrendEvent"),
            zIndex: 2,
            visible: true,
            marker: {
              enabled: false,
            },
            tooltip: {
              valueDecimals: 1,
              valueSuffix: "%",
            },
            data: [
              [new Date(this.formatDatetimeToUTC(period.trendline.start.x)).getTime(), period.trendline.start.y],
              [new Date(this.formatDatetimeToUTC(period.trendline.end.x)).getTime(), period.trendline.end.y],
            ],
          });
        }
      });

      series.push({
        name: "Deviation from baseline",
        type: "line",
        dashStyle: "solid",
        color: this.themeColor("BackgroundBrandPrimary"),
        lineWidth: 2,
        zIndex: 1,
        visible: true,
        enableMouseTracking: true,
        marker: {
          symbol: "circle",
        },
        tooltip: {
          valueDecimals: 1,
          valueSuffix: "%",
        },
        data: longTrendData,
      });

      series.push({
        name: "Benchmark",
        type: "line",
        dashStyle: "dash",
        color: this.themeColor("ContentInfoDefault"),
        zIndex: 4,
        visible: false,
        tooltip: {
          valueDecimals: 1,
          valueSuffix: "%",
        },
        data: this.longTrend.useManualBenchmarkLevel
          ? [
              [new Date(this.formatDatetimeToUTC(this.firstLongTrendPeriod?.start)).getTime(), this.longTrend.manualBenchmarkLevel],
              [new Date().getTime(), this.longTrend.manualBenchmarkLevel],
            ]
          : benchmarkingData,
      });

      series.push({
        name: "Baseline",
        type: "line",
        dashStyle: "dash",
        color: this.themeColor("ContentInverseTertiary"),
        lineWidth: 2,
        enableMouseTracking: false,
        visible: true,
        marker: {
          enabled: false,
        },
        data: [
          [new Date(this.formatDatetimeToUTC(this.firstLongTrendPeriod?.start)).getTime(), 0],
          [new Date().getTime(), 0],
        ],
      });

      return series;
    }
  }

  get chartOptions(): any {
    if (!this.longTrendPeriods?.length) return {};

    const options = {
      time: {
        useUTC: false,
      },
      chart: {
        type: "line",
        zoomType: "x",
        spacingRight: 20,
        animation: false,
        height: 436,
        spacingTop: 40,
        backgroundColor: this.themeColor("BackgroundPrimaryDefault"),
        style: { fontFamily: "Helvetica Neue" },
      },
      credits: {
        enabled: false,
      },
      navigation: {
        menuStyle: {
          color: this.themeColor("ContentPrimary"),
          backgroundColor: this.themeColor("BackgroundElevatedPrimaryDefault"),
          borderColor: this.themeColor("BorderBrandTertiary"),
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.08)",
          borderRadius: "8px",
          display: "flex",
          flex: "1 0 0",
          flexDirection: "column",
          alignItems: "flex-start",
          alignSelf: "stretch",
        },
        menuItemStyle: {
          color: this.themeColor("ContentPrimary"),
          fontSize: "14px",
          fontWeight: "400",
          display: "flex",
          alignItems: "center",
          alignSelf: "stretch",
          padding: "8px",
          margin: "2px 6px",
          borderRadius: "6px",
        },
        menuItemHoverStyle: {
          background: this.themeColor("BackgroundBrandTertiaryPressed"),
          color: this.themeColor("ContentPrimary"),
        },
      },
      legend: {
        enabled: true,
        itemStyle: {
          fontSize: "14px",
          color: this.themeColor("ContentTertiary"),
          fontWeight: "400",
        },
      },
      title: {
        text: null,
      },
      yAxis: {
        title: {
          text: "",
        },
        min: this.firstLongTrendPeriod?.isRpmDiagnostic ? -25 : -50,
        max: this.firstLongTrendPeriod?.isRpmDiagnostic ? 25 : 50,
        labels: {
          format: "{value}%",
          style: { color: this.themeColor("ContentPrimary") },
        },
        gridLineColor: this.themeColor("ContentInverseSecondary"),
      },
      xAxis: {
        title: {
          text: null,
        },
        type: "datetime",
        plotLines: this.vesselEventPlotLines,
        plotBands: this.vesselEventPlotBands,
        labels: {
          y: 35,
          style: { color: this.themeColor("ContentPrimary") },
        },
        minorTickLength: 0,
        tickLength: 0,
      },
      series: this.dataSeries,
      tooltip: {
        backgroundColor: this.themeColor("BackgroundTooltip"),
        borderWidth: 0,
        borderRadius: 16,
        padding: 12,
        shadow: false,
        style: {
          color: "#EBEBEB",
        },
      },
      plotOptions: {
        series: {
          zIndex: 1,
        },
      },
      exporting: {
        filename: `${this.vessel?.name}_${this.longTrend.descriptionLong}`,
        chartOptions: {
          legend: {
            enabled: false,
          },
          title: {
            text: `${this.vessel?.name} [${this.longTrend.descriptionLong}]`,
            style: {
              width: "450px",
            },
          },
        },
        buttons: {
          contextButton: {
            borderRadius: 8,
            x: 20,
            y: -40,
          },
        },
      },
    };

    return options;
  }

  get disableSaveBenchmarkLevelSettings(): boolean {
    // Only allow save if changed and value is valid
    if (!this.isBenchmarkSettingsChanged) return true;
    if (typeof this.manualBenchmarkLevel !== "number" || !Number.isFinite(this.manualBenchmarkLevel) || this.manualBenchmarkLevel > 40 || this.manualBenchmarkLevel < -40) return true;
    return false;
  }

  get isBenchmarkSettingsChanged(): boolean {
    // If type changed, always allow save (even if level is the same)
    if (this.benchmarkType !== this.OriginalBenchmarkSettings.benchmarkType) return true;
    // If manual and value changed
    if (this.benchmarkType === "Manual" && Number(this.manualBenchmarkLevel) !== Number(this.OriginalBenchmarkSettings.manualBenchmarkLevel)) return true;
    return false;
  }

  onBenchmarkMenuInput(val: boolean): void {
    this.OriginalBenchmarkSettings.isBenchmarkMenuOpen = val;
    if (!val) {
      // Menu closed, revert if not saved
      this.benchmarkType = this.OriginalBenchmarkSettings.benchmarkType;
      this.manualBenchmarkLevel = this.OriginalBenchmarkSettings.manualBenchmarkLevel;
      this.useManualBenchmarkLevel = this.OriginalBenchmarkSettings.useManualBenchmarkLevel;
    } else {
      // Menu opened, store originals
      this.OriginalBenchmarkSettings.benchmarkType = this.benchmarkType;
      this.OriginalBenchmarkSettings.manualBenchmarkLevel = this.manualBenchmarkLevel;
      this.OriginalBenchmarkSettings.useManualBenchmarkLevel = this.useManualBenchmarkLevel;
    }
  }

  benchmarkLevelInputRules(value: any): boolean | string {
    if (value === null || value === undefined || value === "") return "Enter benchmark level";
    if (typeof value !== "number" || !Number.isFinite(value)) return "Benchmark level must be a number";
    if (value < -40 || value > 40) return "Benchmark level must be between -40 and 40.";
    return true;
  }

  resetManualBenchmarkLevel(): void {
    this.manualBenchmarkLevel = this.longTrend ? this.longTrend.manualBenchmarkLevel : 0;
  }

  onBenchmarkTypeChange(): void {
    if (this.benchmarkType === "Automatic") {
      this.manualBenchmarkLevel = 0;
      this.useManualBenchmarkLevel = false;
    } else {
      this.manualBenchmarkLevel = this.longTrend.manualBenchmarkLevel;
      this.useManualBenchmarkLevel = true;
    }
  }

  async updateBenchmarkLevelSettings(): Promise<void> {
    this.isBenchmarkLevelSettingsLoading = true;
    const updatedLongTrend: ILongTrend = JSON.parse(JSON.stringify(this.longTrend));
    updatedLongTrend.useManualBenchmarkLevel = this.benchmarkType === "Manual";
    updatedLongTrend.manualBenchmarkLevel = this.manualBenchmarkLevel;

    try {
      await LongTrends.updateVesselLongTrend({ vesselId: this.vessel!.id, longTrend: updatedLongTrend });
      await Vessels.updateCurrentVesselById(this.vessel!.id);
      this.OriginalBenchmarkSettings.benchmarkType = this.benchmarkType;
      this.OriginalBenchmarkSettings.manualBenchmarkLevel = this.manualBenchmarkLevel;
      this.OriginalBenchmarkSettings.useManualBenchmarkLevel = this.useManualBenchmarkLevel;
      Snackbar.showSnackbar({ text: "Benchmark settings successfully updated", color: "ContentPrimaryStatic" });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to update benchmark settings" });
    } finally {
      this.isBenchmarkLevelSettingsLoading = false;
    }
  }

  onFilterUpdated(): void {
    this.$emit("onFilterUpdated");
  }

  formatDatetimeToUTC(datetime: any): any {
    datetime = datetime.split("+");
    return datetime[0].endsWith("z") || datetime[0].endsWith("Z") ? datetime[0] : datetime[0] + "Z";
  }

  formatDateForDisplay(date: any): string {
    return moment.utc(date).format("DD.MMM YYYY");
  }

  getLongTrendPeriodMeta(longTrendPeriod: ILongTrendPeriod): Partial<LongTrendPeriodMeta> {
    return {
      longTrendId: longTrendPeriod.longTrendId,
      longTrendName: this.longTrendName,
      vesselId: longTrendPeriod.vesselId,
      startDate: moment.utc(longTrendPeriod.start).toISOString(),
      endDate: moment.utc(longTrendPeriod.end).toISOString(),
    };
  }

  eventIcon(eventType: string): string {
    return eventType === "TrendEvent" ? "mdi-alpha-t-circle" : "mdi-alpha-i-circle";
  }

  eventColor(eventType: string): string {
    return eventType === "InfoEvent" ? this.themeColor("BackgroundDataVizInfoEvent") : this.themeColor("BackgroundDataVizTrendEvent");
  }
}
